import { AppointmentPhase, Status } from "components";
import { PhosphorWarningInline } from "components/Atoms/PhosphorIcon";
import { ShowSidePanel } from "components/SidePanel/Show/ShowSidePanel";
import React from "react";

interface Props {
  show: server.dto.ShowForListInternal;
  hideProduction?: boolean;
  hideCostCenter?: boolean;
}

const ShowNameForListInternal = ({ show, hideProduction }: Props) => {
  const hasProjectCode = Boolean(show.projectCode);
  const hasCostCenter = Boolean(show.costCenter);
  const displayProjectCodeOrCostCenter = (hasProjectCode || hasCostCenter) && !hideProduction;

  return (
    <div className="flex gap">
      <div>
        <AppointmentPhase value={show.status.appointmentPhase} displayLabel={false} />
      </div>
      <div className="flex-column gap-small grow1">
        <div className="flex gap-small">
          {show.locked === "locked" && <div style={{ marginLeft: -3 }}><i className="icon-lock"></i></div>}
          <ShowSidePanel
            showId={show.showId}
            trigger={
              <a style={{ width: "100%" }}>
                {!show.validated && <PhosphorWarningInline />}
                {show.eventName || "..."}
              </a>
            }
            canEdit={show.permissions.canModify}
          />
        </div>
        <div>
          <Status status={show.status} />
        </div>
        {displayProjectCodeOrCostCenter && <div className="s1_small">

          {hasCostCenter && <span>
            {show.costCenter.internalId}
          </span>}
          {hasProjectCode && hasCostCenter && <span>
            {" | "}
          </span>}
          {hasProjectCode && <span>
            {show.projectCode}
          </span>}

        </div>}

        {(!hideProduction && show.productionName) && <div className="s1_small">
          {show.productionName}
        </div>}
      </div>
    </div>
  );
};

export default ShowNameForListInternal;